import type {KeyTextField} from '@prismicio/client'
import {LetterLink} from './LetterLink'

export interface AlphabetNavigationProps {
  availableLetters: Set<string>
  navigationAriaLabel?: KeyTextField
  variant?: 'desktop' | 'mobile'
}

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')

export function AlphabetNavigation({
  availableLetters,
  navigationAriaLabel,
  variant = 'desktop',
}: AlphabetNavigationProps) {
  const ariaLabelPrefix = navigationAriaLabel || 'Jump to terms starting with'

  if (variant === 'mobile') {
    return (
      <nav
        className="absolute right-4 top-4 z-10 max-h-[calc(100%-2rem)] overflow-y-auto rounded border border-moss-grey-100 bg-moss-white p-2 shadow-sm lg:hidden"
        aria-label="Alphabet navigation"
      >
        <div className="flex flex-col gap-1.5">
          {ALPHABET.map((letter) => (
            <LetterLink
              key={letter}
              letter={letter}
              isAvailable={availableLetters.has(letter)}
              size="xs"
              ariaLabelPrefix={ariaLabelPrefix}
            />
          ))}
        </div>
      </nav>
    )
  }

  return (
    <nav
      className="sticky top-18 z-10 mx-auto hidden max-w-[1200px] rounded-lg border border-moss-grey-100 bg-moss-white lg:block"
      aria-label="Alphabet navigation"
    >
      <div className="grid grid-cols-main">
        <div className="col-[inner] overflow-x-auto">
          <div className="flex min-w-max gap-2.5 py-3">
            {ALPHABET.map((letter) => (
              <LetterLink
                key={letter}
                letter={letter}
                isAvailable={availableLetters.has(letter)}
                size="sm"
                ariaLabelPrefix={ariaLabelPrefix}
              />
            ))}
          </div>
        </div>
      </div>
    </nav>
  )
}
